/**
 * A simple wrapper around react-i18next's useTranslation,
 * with the useSuspense set to false (since it is default true).
 * Since we do not use Suspense, this hook should be imported rather
 * than importing directly from react-i18next.
 */
import { useCallback } from 'react';
import i18next, { TFunction, i18n, TOptions } from 'i18next';
import { useTranslation as baseUseTranslation } from 'react-i18next';
import { KeyParam } from 'js/i18next/i18n.d';

const useTranslation = (namespace: KeyParam): [TFunction, i18n] => {
  const [t, i18nInstance] = baseUseTranslation(namespace, {
    useSuspense: false,
  });
  const debugT: TFunction = useCallback(
    (key: KeyParam, opts?: TOptions | string) => {
      let keys;
      if (Array.isArray(key)) keys = [...key, 'keyNotDefined'];
      else keys = [key, 'keyNotDefined'];
      return t(keys, opts);
    },
    [t],
  );
  if (i18next.store.options.debug) return [debugT, i18nInstance];
  return [t, i18nInstance];
};

export default useTranslation;
